import { expect, Locator, Page } from "@playwright/test";

export const getFilterButton = (page) => {
    return page.locator("ux-iws-stateful-filter-button").first();
};

export const getFilterTags = (page) => {
    return page.locator("ux-iws-stateful-filter-tags").first();
};

export const testSwitchFromTilesToTableView = async (
    statefulOverview: Locator
) => {
    const tilesViewButton = statefulOverview.locator("ux-button[icon=tiles]");
    const tableViewButton = statefulOverview.locator("ux-button[icon=list]");

    // tiles view initially selected
    await expect(tilesViewButton).toHaveAttribute("selected");
    await expect(tableViewButton).not.toHaveAttribute("selected");
    await expect(
        statefulOverview.locator("ux-iws-stateful-tiles")
    ).toBeVisible();

    // switch to table view
    await tableViewButton.click();
    await expect(tilesViewButton).not.toHaveAttribute("selected");
    await expect(tableViewButton).toHaveAttribute("selected");
    await expect(
        statefulOverview.locator("ux-iws-stateful-table")
    ).toBeVisible();
};

export const testSwitchFromTableToTilesView = async (
    statefulOverview: Locator
) => {
    const tilesViewButton = statefulOverview.locator("ux-button[icon=tiles]");
    const tableViewButton = statefulOverview.locator("ux-button[icon=list]");

    // table view initially selected
    await expect(tilesViewButton).not.toHaveAttribute("selected");
    await expect(tableViewButton).toHaveAttribute("selected");
    await expect(
        statefulOverview.locator("ux-iws-stateful-table")
    ).toBeVisible();

    // switch to tiles view
    await tilesViewButton.click();
    await expect(tilesViewButton).toHaveAttribute("selected");
    await expect(tableViewButton).not.toHaveAttribute("selected");
    await expect(
        statefulOverview.locator("ux-iws-stateful-tiles")
    ).toBeVisible();
};

export const testStatefulOverviewTiles = async (statefulOverview: Locator) => {
    await expect(
        statefulOverview.locator("ux-iws-stateful-tiles")
    ).toBeVisible();

    // test tiles data
    // option 1: test if first tile is visible
    await expect(
        statefulOverview
            .locator("ux-iws-stateful-tiles")
            .locator("ux-iws-tile")
            .first()
    ).toBeVisible();

    // option 2: test number of tiles
    const numResults = await statefulOverview
        .locator("ux-iws-stateful-tiles")
        .locator("ux-iws-tile")
        .count();
    expect(numResults).toBeGreaterThan(0);
};

export const testStatefulOverviewTable = async (statefulOverview: Locator) => {
    await expect(
        statefulOverview.locator("ux-iws-stateful-table")
    ).toBeVisible();

    // test table data
    // option 1: test if first row is visible
    await expect(
        statefulOverview
            .locator("ux-iws-stateful-table")
            .locator("tbody > tr")
            .first()
    ).toBeVisible();

    // option 2: test number of rows
    const numResults = await statefulOverview
        .locator("ux-iws-stateful-table")
        .locator("tbody > tr")
        .count();
    expect(numResults).toBeGreaterThan(0);
};

export const testStatefulOverviewEmptyResult = async (
    statefulOverview: Locator
) => {
    await expect(
        statefulOverview.locator("ux-iws-stateful-tiles")
    ).not.toBeVisible();
    await expect(
        statefulOverview.locator("ux-iws-stateful-table")
    ).not.toBeVisible();
    await expect(statefulOverview.locator("ux-icon[name=cross]")).toBeVisible();
};

export const testStatefulFilterSidebarOpening = async (page: Page) => {
    const filterButton = getFilterButton(page);
    const sidebar = page.locator("ux-sidebar").first();

    // Sidebar should be initially closed
    await expect(sidebar.locator(".ux-sidebar__head")).not.toBeInViewport();
    await expect(sidebar.locator("ux-sidebar-content")).not.toBeInViewport();
    await expect(sidebar.locator(".ux-sidebar__backdrop")).not.toBeVisible();

    // Sidebar should open
    await filterButton.click();
    await expect(sidebar.locator(".ux-sidebar__head")).toBeInViewport();
    await expect(sidebar.locator("ux-sidebar-content")).toBeInViewport();
    await expect(sidebar.locator("ux-sidebar-content")).toBeVisible();
    await expect(sidebar.locator(".ux-sidebar__backdrop")).toBeVisible();
};

export const testStatefulFilterSidebarClosingViaCloseButton = async (
    page: Page
) => {
    const sidebar = page.locator("ux-sidebar").first();

    // Sidebar should be initially opened
    await expect(sidebar.locator("ux-sidebar-content")).toBeInViewport();

    // Sidebar should close
    await sidebar.locator(".ux-sidebar__close").click();
    await expect(sidebar.locator("ux-sidebar-content")).not.toBeInViewport();
    await expect(sidebar.locator(".ux-sidebar__backdrop")).not.toBeVisible();
};

export const testStatefulFilterSidebarClosingViaCloseBackdrop = async (
    page: Page
) => {
    const sidebar = page.locator("ux-sidebar").first();

    // Sidebar should be initially opened
    await expect(sidebar.locator("ux-sidebar-content")).toBeInViewport();

    // Sidebar should close
    await sidebar.locator(".ux-sidebar__backdrop").click();
    await expect(sidebar.locator("ux-sidebar-content")).not.toBeInViewport();
    await expect(sidebar.locator(".ux-sidebar__backdrop")).not.toBeVisible();
};

export const testStatefulFilterSidebarClosingViaEscKey = async (page: Page) => {
    const sidebar = page.locator("ux-sidebar").first();

    // Sidebar should be initially opened
    await expect(sidebar.locator("ux-sidebar-content")).toBeInViewport();

    // Sidebar should close
    await page.keyboard.press("Escape");
    await expect(sidebar.locator("ux-sidebar-content")).not.toBeInViewport();
    await expect(sidebar.locator(".ux-sidebar__backdrop")).not.toBeVisible();
};
